import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertToastComponent } from 'app/main/alert-toast/alert-toast.component';
import { DashboardHeaderNavComponent } from 'app/main/dashboard-header-nav/dashboard-header-nav.component';
import { DashboardPopupAlertComponent } from 'app/main/dashboard-popup-alert/dashboard-popup-alert.component';
import { EntitySidebarComponent } from 'app/main/entity-sidebar/entity-sidebar.component';
import { EntitySideBarService } from 'app/main/entity-sidebar/entity-sidebar.service';
import { LoadingComponent } from 'app/main/loading/loading.component';
import { ScrollTopComponent } from 'app/main/scroll-top/scroll-top.component';
import { ThemeService } from 'shared/core/services/theme.service';
import { SupportPageContextDirective } from 'shared/core/services/support-page-context.directive';
import { HAS_ENTITY_SIDEBAR } from 'shared/interfaces/shared-interfaces';

@Component({
    selector: 'app-full-layout',
    standalone: true,
    imports: [
        RouterOutlet,
        SupportPageContextDirective,
        EntitySidebarComponent,
        ScrollTopComponent,
        LoadingComponent,
        DashboardHeaderNavComponent,
        DashboardPopupAlertComponent,
        AlertToastComponent,
    ],
    templateUrl: './full-layout.component.html',
    providers: [{ provide: HAS_ENTITY_SIDEBAR, useValue: true }],
})
export class FullLayoutComponent {
    sidebar = inject(EntitySideBarService);
    themeService = inject(ThemeService);
}
